<template>
    <div>
        <fieldset>
            <legend class="text-blue">
                {{ $t("journalEntry.chartOfAccount") }}
                <Tooltip placement="top">
                    <Icon type="ios-information-circle-outline" size="17" />
                    <div slot="content">
                        <div class="tw-text-xs">
                            Double click on table row or click icon
                        </div>
                        <span class="tw-text-xs"
                            >plus to add item in to item details.</span
                        >
                    </div>
                </Tooltip>
            </legend>
            <div>
                <div class="tw-flex tw-justify-between tw-mb-3">
                    <Select
                        v-model="acc_cat_id"
                        :options="coaCategories"
                        show-search
                        :allowClear="true"
                        style="width: 380px"
                        :class="{ 'is-invalid': errors.has('expense_type') }"
                        placeholder="Filter by CoA Category"
                        @change="getCoaSetup"
                    ></Select>
                    <Input
                        v-model="search"
                        search
                        :placeholder="$t('journalEntry.searchCoaSetup')"
                        style="width: 309px"
                    />
                </div>
                <Table
                    height="150"
                    border
                    :columns="columns"
                    :data="coaSetupLists"
                    size="small"
                    :loading="coaSetupLoading"
                    @on-row-dblclick="onAddItem"
                    :row-class-name="rowClassName"
                >
                    <template slot-scope="{ row }" slot="currency_id">
                        {{
                            row.currency
                                ? row.currency.currency_name_en +
                                  "|" +
                                  row.currency.currency_code
                                : ""
                        }}
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <Tooltip
                            placement="top"
                            :transfer="true"
                            :content="$t('add')"
                        >
                            <a
                                href="#"
                                class="text-blue"
                                @click.prevent="onAddItem(row)"
                            >
                                <Icon
                                    type="ios-add-circle-outline"
                                    size="20"
                                />
                            </a>
                        </Tooltip>
                    </template>
                </Table>
            </div>
        </fieldset>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import { orderBy, debounce } from "lodash";

export default {
    name: "chartOfAccount",
    props: ["value", "validate"],
    data() {
        return {
            errors: new Errors(),
            coaSetupLoading: false,
            acc_cat_id: undefined,
            search: "",
            model: {}
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("accounting/journalEntry", ["formViewDatas", "edit_data"]),
        coaCategories() {
            if (this.formViewDatas["coaCategories"]) {
                return this.formViewDatas["coaCategories"].map(el => ({
                    value: el.acc_cat_id,
                    label: el.acc_cat_type + " | " + el.acc_cat_name_en
                }));
            }
            return [];
        },
        coaSetupLists() {
            return orderBy(this.formViewDatas["coaSetups"], ["currency_id"]);
        },
        columns() {
            return [
                {
                    title: this.$t("journalEntry.accountNumber"),
                    key: "account_number",
                    fixed: "left",
                    width: 100
                },
                {
                    title: this.$t("journalEntry.accountName"),
                    key: "account_name_en"
                },
                {
                    title: this.$t("journalEntry.currency"),
                    slot: "currency_id",
                    align: "center",
                    width: 120
                },
                {
                    title: this.$t("actions"),
                    slot: "action",
                    fixed: "right",
                    align: "center",
                    className: "tw-space-x-2",
                    width: 85
                }
            ];
        }
    },
    methods: {
        ...mapActions("accounting/journalEntry", ["getFormViewModel"]),
        async getCoaSetup() {
            this.coaSetupLoading = true;
            await this.getFormViewModel({
                index: "coaSetups",
                params: {
                    fnName: "coaSetups",
                    currency_id: this.model.currency_id,
                    acc_cat_id: this.acc_cat_id,
                    search: this.search
                }
            }).finally(() => {
                this.coaSetupLoading = false;
            });
        },
        rowClassName() {
            return "cursor-pointer";
        },
        cellClassName() {
            return "demo-table-info-column";
        },
        onAddItem(row) {
            this.model.details.push({
                transaction_id: null,
                account_id: row.account_id,
                account_number: row.account_number,
                account_name_en: row.account_name_en,
                currency_code: row.currency ? row.currency.currency_code : "",
                remarks: null,
                currency_id: this.model.currency_id,
                debit_amount: null,
                credit_amount: null,
                display_order: this.model.details.length + 1
            });
        }
    },
    watch: {
        validate: function(error) {
            this.errors = new Errors(error.errors);
        },
        search: debounce(function() {
            this.getCoaSetup();
        }, 500)
    }
};
</script>
<style>
.ant-calendar-picker-input {
    height: 32px !important;
}
</style>
<style scoped>
.form-control {
    height: 32px;
}
</style>
